import React from 'react';
import { FormControl, ListSubheader, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { SalesChannel } from '@api/SalesChannels/SalesChannel';
import { TableKiosk } from '@api/TablesKiosks/TableKiosk';

// Canal de venta / mesa. Vivía dentro de `OrderCustomerForm`; desde el ajuste de
// Irving (2026-08-27) vive **al inicio de la fila de botones de cobro**, compacto:
// es lo último que se define antes de cerrar la venta y ahí ocupa menos alto.
//
// ⚠️ MESAS (D8 del plan): elegir mesa fuerza `waitingForPayment` y elegir canal lo
// apaga — esa lógica NO vive aquí, sigue en `handleChannelTableChange` del POS.
// Este componente solo pinta el selector.
interface OrderChannelSelectProps {
    salesChannels: SalesChannel[];
    tables: TableKiosk[];
    selectedOption: string;
    onSelectOptionChange: (event: SelectChangeEvent<string>) => void;
    width?: number;
}

export const OrderChannelSelect: React.FC<OrderChannelSelectProps> = ({
    salesChannels,
    tables,
    selectedOption,
    onSelectOptionChange,
    width = 150
}) => (
    <FormControl sx={{ width, flexShrink: 0 }}>
        <Select
            value={selectedOption || ''}
            onChange={onSelectOptionChange}
            displayEmpty
            renderValue={(value) => {
                if (!value) return 'Canal';
                if (value.startsWith('table-')) {
                    return tables.find((table) => table.id === value.replace('table-', ''))?.name || 'Mesa';
                }
                return (
                    salesChannels.find((channel) => channel.id === value.replace('channel-', ''))?.name || 'Canal'
                );
            }}
        >
            <ListSubheader>Canales de Venta</ListSubheader>
            {salesChannels.map((channel) => (
                <MenuItem key={`channel-${channel.id}`} value={`channel-${channel.id}`}>
                    {channel.name}
                </MenuItem>
            ))}
            {tables.length > 0 && <ListSubheader>Mesas</ListSubheader>}
            {tables.map((table) => (
                <MenuItem key={`table-${table.id}`} value={`table-${table.id}`}>
                    {table.name}
                </MenuItem>
            ))}
        </Select>
    </FormControl>
);
